import styled from 'styled-components';

export const MotionListStyled = styled.div`
  flex: 1;
  padding: ${props => props.theme.size.rap};
  background: #fff;

  .action-button {
    margin-top: 2rem;
  }
`;
